import { defineStore } from 'pinia';
import { CUSTOM_ROOM } from '@nextories/vue-core-components/src/store/furnituresStore';
import notificationWrapper from '@/utils/helpers/notificationWrapper';
import { useProjectStore } from './projectStore';
import type { Furniture, InventoryState } from '@/types/Inventory';
import type { Room } from '@nextories/vue-core-components/src/types/Furnitures';

export const useInventoryStore = defineStore('inventory', {
  state: (): InventoryState => ({
    inventoryLoading: false,
    rooms: [],
    roomsLoading: false,
    services: [],
    servicesLoading: false,
  }),

  actions: {
    async getRooms() {
      this.roomsLoading = true;
      try {
        const projectStore = useProjectStore();
        const data = await window.appConnector.getRooms(projectStore.projectIdSelected);
        this.setRooms(Array.isArray(data) ? data : data.display);
        this.roomsLoading = false;
      } catch (error) {
        this.setRooms([]);
        this.roomsLoading = false;
        if (!error || error.status !== 404) {
          notificationWrapper();
          throw error;
        }
      }
    },

    async getServices() {
      this.servicesLoading = true;
      try {
        const projectStore = useProjectStore();
        const data = await window.appConnector.getServices(projectStore.projectIdSelected);
        this.services = Array.isArray(data) ? data : data.display;
        this.servicesLoading = false;
      } catch (error) {
        this.servicesLoading = false;
        notificationWrapper();
        if (error.status === 404) {
          return;
        }
        throw error;
      }
    },

    async postInventory(inventory: Furniture) {
      this.inventoryLoading = true;
      try {
        const projectStore = useProjectStore();
        await window.appConnector.postInventory(projectStore.projectIdSelected, inventory);
        this.inventoryLoading = false;
      } catch (error) {
        notificationWrapper();
        this.inventoryLoading = false;
        if (error.status === 404) {
          return;
        }
        throw error;
      }
    },

    setRooms(rooms: Room[]) {
      this.rooms = rooms.map((room) => ({
        id: room.name + Math.random().toString(36).substring(2, 9),
        piece_type: CUSTOM_ROOM,
        ...room,
      }));
    },
  },
});
